import { useMemo } from 'react';
import {
  METRICS_NAMES_LOCALE_KEYS_MAP,
  GSD_METRICS_NAMES_LOCALE_KEYS_MAP,
} from '@/pages/intelligence/pages/TopCharts/components/DetailsPage/CardContext/constants';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';

// Overview卡片数据整合hooks
const useOverviewCardHooks = (props: any) => {
  const { moduleName, titleContentTemp: titleContent, cardItem, isOperateRegion } = props || {};
  // console.log('useOverviewCardHooks', props);

  const { formatMessage } = useIntlExtend();
  const usMetricList = ['digitalARPPU', 'physicalRevenue'];

  const getMetricTitle = (metric: string, moduleName: string): string => {
    if (moduleName === 'companies') {
      return metric?.endsWith('Revenue') ? `${metric}($)` : metric;
    }
    return metric === 'PHeat' ? 'P.Heat' : metric;
  };

  const getMetricTitleLocaleKey = (metricName: string): string => {
    const metricNameLocaleKey =
      cardItem?.data_source === 'gsd'
        ? GSD_METRICS_NAMES_LOCALE_KEYS_MAP[metricName]
        : METRICS_NAMES_LOCALE_KEYS_MAP[metricName];
    return metricNameLocaleKey ? formatMessage({ id: metricNameLocaleKey }) : metricName;
  };

  const metricTitle = getMetricTitle(titleContent, moduleName);
  const metricTitleLocaleKey = getMetricTitleLocaleKey(metricTitle);

  const getIsUsMetric = (cardItem: any) => {
    if (cardItem?.data_source !== 'gsd') {
      if (!isOperateRegion && cardItem?.metricUserGuide === 'digitalRevenue') {
        return true;
      }
      if (usMetricList.includes(cardItem?.metricUserGuide)) {
        return true;
      }
    }
    return false;
  };

  const titleContentValue = useMemo(() => {
    if (getIsUsMetric(cardItem)) {
      return `US ${cardItem.titleContent}`;
    }
    return titleContent;
  }, [titleContent, cardItem]);

  return {
    metricTitleLocaleKey,
    titleContentValue,
  };
};

export default useOverviewCardHooks;
